import { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { SCREEN } from '../../../../../../common/selectCurrencyUnit/constant'
import { useFormatCurrency } from '../../../../../../common/selectCurrencyUnit/useFormatCurrency'
import { convertData } from '../../../../../../helpers/value'
import {
  getNoDataComponent,
  getStyleHeightContainer,
  handleIconDownload,
} from '../../../helper'
import { selectDataViewByTrend, selectIndicatorById } from '../store/slice'
import ChartLeft from './ChartLeft'
import ChartRight from './ChartRight'
import { RATIO_CODE } from './constant'

const Trend = ({ id, isDynamicReport, check, isDownloadComponent }) => {
  const { getExchangeRate, multiplier } = useFormatCurrency(
    SCREEN.FINANCIAL_ANALYSIS,
  )
  const dataByTrend = useSelector(selectDataViewByTrend)
  const indicatorById = useSelector(selectIndicatorById)

  const dataConvert = convertData(
    dataByTrend,
    getExchangeRate,
    indicatorById,
    multiplier,
    ['year'],
    [RATIO_CODE.AVERAGE_COST, RATIO_CODE.CREDIT_COST, RATIO_CODE.LOAN_YIELD],
  )

  const isNoData = !dataByTrend?.length

  useEffect(() => {
    handleIconDownload(id, isNoData)
  }, [isNoData])

  if (isNoData) {
    return getNoDataComponent(isDynamicReport)
  }

  return (
    <div
      style={{
        height: isDownloadComponent
          ? '100%'
          : getStyleHeightContainer(isDynamicReport, isNoData, 332),
      }}
      className="dFlex"
    >
      <div className="w50 h100 pr1">
        <ChartLeft
          id={id}
          data={dataConvert}
          isDynamicReport={isDynamicReport || isDownloadComponent}
          check={check}
        />
      </div>
      <div className="w50 h100 pl1">
        <ChartRight
          id={id}
          data={dataConvert}
          isDynamicReport={isDynamicReport || isDownloadComponent}
        />
      </div>
    </div>
  )
}

export default Trend
